import { ComponentProps } from 'react';

import { Box } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';

import { styledBoxClass } from './Overview.css';

interface StyledBoxProps extends ComponentProps<typeof Box> {
  className?: string;
}

export const StyledBox = ({ className, ...props }: StyledBoxProps) => (
  <Box className={getClassNames(styledBoxClass, className)} {...props} />
);
